import * as React from 'react';
import * as _ from 'lodash';
import {useRef, useState} from 'react';

type ChildrenRefs = {[key: string]: HTMLDivElement};

export interface ChildrenRefsContextProps {
  childrenRefs: ChildrenRefs;
  addChildRef: (key: string, ref: HTMLDivElement) => void;
  removeChildRef: (key: string) => void;
}

export const ChildrenRefsContext = React.createContext<ChildrenRefsContextProps>({
  childrenRefs: {},
  addChildRef: null,
  removeChildRef: null,
});
const Provider = ChildrenRefsContext.Provider;

const withChildrenRefsProvider = WrappedComponent => {
  return function ComponentWithChildrenRefs<T extends any>(props) {
    const [childrenRefs, setChildrenRefs] = useState<ChildrenRefs>({});
    const childrenRefsRef = useRef({});

    const addChildRef = (key: string, ref: HTMLDivElement) => {
      childrenRefsRef.current = {...childrenRefsRef.current, [key]: ref};
      setChildrenRefs(childrenRefsRef.current);
    };

    const removeChildRef = (key: string) => {
      if (childrenRefsRef.current[key]) {
        childrenRefsRef.current = _.omit(childrenRefsRef.current, key);
        setChildrenRefs(childrenRefsRef.current);
      }
    };

    return (
      <Provider
        value={{
          childrenRefs,
          addChildRef,
          removeChildRef,
        }}
      >
        <WrappedComponent {...props} />
      </Provider>
    );
  };
};

export default withChildrenRefsProvider;
